var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveProjectMapaf215F79(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.359375,
    y: 0.464844,
    width: 34.069,
    height: 34.069,
    rx: 4,
    fill: "#C8C8C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7625 10.2891L11.0265 9.37607C10.7259 9.27593 10.4057 9.24867 10.0924 9.29654C9.77917 9.3444 9.48176 9.46603 9.22472 9.65139C8.96768 9.83674 8.75836 10.0805 8.61403 10.3627C8.46969 10.6448 8.39445 10.9572 8.39453 11.2741V23.0571C8.39443 23.477 8.52651 23.8863 8.77205 24.227C9.01758 24.5676 9.36412 24.8224 9.76253 24.9551L13.7625 26.2881C14.1728 26.4247 14.6163 26.4247 15.0265 26.2881L19.7625 24.7101C20.1728 24.5734 20.6163 24.5734 21.0265 24.7101L23.7625 25.6221C24.0633 25.7222 24.3835 25.7495 24.6969 25.7016C25.0102 25.6536 25.3077 25.5319 25.5647 25.3465C25.8218 25.161 26.0311 24.9171 26.1754 24.6348C26.3197 24.3526 26.3948 24.0401 26.3945 23.7231V11.9411C26.3947 11.5213 26.2628 11.112 26.0174 10.7714C25.7721 10.4307 25.4258 10.1759 25.0275 10.0431L21.0275 8.71007C20.617 8.57321 20.1731 8.57321 19.7625 8.71007L15.0255 10.2881C14.6153 10.4247 14.1718 10.4247 13.7615 10.2881L13.7625 10.2891Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3945 10.5V26.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3945 8.5V24.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveProjectMapaf215F79);
export default __webpack_public_path__ + "static/media/active-project-map.af215f79.2c8994d165b0b92558f9fcd333d4a1da.svg";
export { ForwardRef as ReactComponent };